<div class="container">
    <ig-navigation *ngIf="showNav"></ig-navigation>
    <main>
        <router-outlet></router-outlet>
    </main>
</div>
<ig-frame-indicator [isEnabled]="showFrameIndicator"
    [frameHeight]="frameIndicatorHeight"></ig-frame-indicator>
